import React, { useEffect, useState } from 'react'
import './OurActivities.scss'

import { Swiper, SwiperSlide } from 'swiper/react'

import 'swiper/css'
import 'swiper/css/pagination'

import { Pagination } from 'swiper/modules'

import 'aos/dist/aos.css'
import Aos from 'aos'

export default function OurActivities() {
  const [swiper, setSwiper] = useState(null)

  const handleOnSetSwiperOne = () => {
    swiper.slideTo(0)
  }

  // const handleOnSetSwiperTwo = () => {
  //   swiper.slideTo(1)
  // }

  const handleOnSetSwiperThree = () => {
    swiper.slideTo(1)
  }

  const handleOnSetSwiperFour = () => {
    swiper.slideTo(2)
  }

  useEffect(() => {
    Aos.init({ duration: 2500, once: true })
  }, [])

  return (
    <div className='mainActivity' data-aos= 'fade-left'>
      <div className='slider'>
        <Swiper pagination={true} modules={[Pagination]} className='mySwiper' onSwiper={setSwiper}>
          <SwiperSlide>
            <div className="mainActivity_sliderOne">
              <h2 className="mainActivity_content">
                STEEL INSDUSTRIAL<br />
                PRODUCTS
              </h2>
            </div>
          </SwiperSlide>
          {/* <SwiperSlide>
            <div className="mainActivity_sliderTwo">
              <h2 className="mainActivity_content">
                MSW PLANT,RECYCLING<br />
                AND WASTE TO POWER<br />
                PLANT PROJECT
              </h2>
              
            </div>
          </SwiperSlide> */}
          <SwiperSlide>
            <div className="mainActivity_sliderThree">
              <h2 className="mainActivity_content">
                BUILDING AND<br />
                CONSTRUCTION
              </h2>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="mainActivity_sliderFour">
              <h2 className="mainActivity_content">
                GENERAL<br />
                TRADING
              </h2>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
      <div className='container'>
        <div className='row'>
          <div className='content'>
            <h2 className='title'>
              OUR MAIN ACTIVITIES
            </h2>
            <h3 className='subtitle'>
              Global Energy Investment and his partner’s leading companies operate in the sector of Steel Industrial, Construction.
            </h3>
            <div className='buttons'>
              <div className='row_buttons'>
                <div className='button' onMouseEnter={handleOnSetSwiperOne}>
                  <div className='img'>
                  </div>
                  <div className='contents'>
                    <div className='buttons_title'>
                      Steel Industrial Products
                    </div>
                    <hr />
                    <div className='buttons_subtitle'>
                    Wire rod , Steel Rebar , Steel Ingot <br />
                    (billet ) , Galvanized wire
                    </div>
                  </div>
                </div>

                {/* <div className='button2' onMouseEnter={handleOnSetSwiperTwo}>
                  <div className='img'>
                    
                  </div>
                  <div className='contents'>
                    <div className='buttons_title'>
                      MSW plant, recycling and waste to
                      power plant project 
                    </div>
                    <hr />
                    <div className='buttons_subtitle'>
                      Refuse-derived Fuel (RDF) , Solid ...
                    </div>
                  </div>
                </div> */}
                <div className='button3' onMouseEnter={handleOnSetSwiperThree}>
                  <div className='img'>
                  </div>
                  <div className='contents'>
                    <div className='buttons_title'>
                      Building & Construction
                    </div>
                    <hr />
                    <div className='buttons_subtitle'>
                      Participation and investment in <br />
                      construction projects
                    </div>
                  </div>
                </div>
              </div>

              <div className='row_buttons'>
                

                <div className='button4' onMouseEnter={handleOnSetSwiperFour}>
                  <div className='img'>
                  </div>
                  <div className='contents'>
                    <div className='buttons_title'>
                      General Trading
                    </div>
                    <hr />
                    <div className='buttons_subtitle'>
                      Steel products , Construction, industrial <br />
                      and mineral materials , Industrial ...
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
